"use client";
import React, { useEffect } from "react";
import { Formik } from "formik";
import { SignInSchema } from "../../utils/formik-schema/signinSchema";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  selectError,
  selectLoading,
  signIn,
} from "../../redux/users/usersSlice";
import Input from "../Input";

function SignInForm() {
  const loading = useSelector(selectLoading);
  const error = useSelector(selectError);
  const dispatch = useDispatch();

  const handleSignIn = async (values) => {
    dispatch(signIn(values));
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  const initialValues = {
    email: "",
    password: "",
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="sm:w-[40%] w-full bg-white rounded-lg shadow-lg p-10">
        <h2 className="mb-6 text-4xl font-bold text-center text-gray-800">
          User Login
        </h2>
        <Formik
          initialValues={initialValues}
          validationSchema={SignInSchema}
          onSubmit={handleSignIn}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <form className="flex flex-col space-y-4" onSubmit={handleSubmit}>
              <Input
                name="email"
                type="email"
                placeholder="Email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.email}
                touched={touched.email}
                className="p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500"
              />
              <Input
                name="password"
                type="password"
                placeholder="Password"
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.password}
                touched={touched.password}
                className="p-3 border-2 border-gray-300 rounded-lg focus:border-blue-500"
              />
              <button
                className={`px-6 py-2 my-2 text-white rounded-md ${
                  loading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-blue-500 hover:bg-blue-600"
                } transition duration-300`}
                type="submit"
                disabled={loading}
              >
                {loading ? "Signing In..." : "Sign In"}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default SignInForm;
